import { getLocale } from "../runtime";

const sv_noorder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Betalningen kunde inte laddas. Säkerställ att du har produkter i kundvagnen, och ladda om sidan. Om problemet kvarstår, kontakta supporten.`
};

const noorder = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_noorder(inputs)
	return "noOrder";
};

export { noorder as "noOrder" };